import { DateTime } from 'luxon';
import MunicipalityApiModel from './municipality.api-model';
import type { ILine } from '../../../models/line.model';
import { TransportModeHelper } from '../../../helpers/transport-mode.helper';
import { TransportSubModeHelper } from '../../../helpers/transport-sub-mode.helper';

export default class LineApiModel {
  gid!: string;
  name!: string;
  shortName!: string;
  technicalLineNumber!: string;
  directionName!: string;
  backgroundColor!: string;
  foregroundColor!: string;
  borderColor!: string;
  transportMode!: string;
  transportSubMode!: string;
  wheelchairAccessible!: boolean;
  isPublicTransport!: boolean;
  municipalities!: MunicipalityApiModel[];
  appliesFrom!: string;
  appliesUpto!: string;
  designation: string | undefined;
  transportAuthorityGid: string | undefined;

  public static mapToBusinessModel(apiModel: LineApiModel): ILine {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
      shortName: apiModel.shortName,
      technicalLineNumber: apiModel.technicalLineNumber,
      directionName: apiModel.directionName,
      backgroundColor: apiModel.backgroundColor,
      foregroundColor: apiModel.foregroundColor,
      borderColor: apiModel.borderColor,
      transportMode: TransportModeHelper.parse(apiModel.transportMode),
      transportSubMode: TransportSubModeHelper.parse(apiModel.transportSubMode),
      isWheelchairAccessible: apiModel.wheelchairAccessible,
      isPublicTransport: apiModel.isPublicTransport,
      municipalities: apiModel.municipalities ? apiModel.municipalities.map(MunicipalityApiModel.mapToBusinessModel) : undefined,
      appliesFrom: apiModel.appliesFrom ? DateTime.fromISO(apiModel.appliesFrom) : undefined,
      appliesUpto: apiModel.appliesUpto ? DateTime.fromISO(apiModel.appliesUpto) : undefined,
      contractorId: undefined,
      designation: apiModel.designation,
      transportAuthorityGid: apiModel.transportAuthorityGid,
    };
  }
}
